import { Alert, AlertTitle, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function AccessDenied() {
  const { t } = useTranslation('common')

  const navigate = useNavigate()

  return (
    <>
      <Alert
        severity="error"
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          p: 10,
          '& .MuiAlert-icon': {
            fontSize: 64,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0
          },
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }}
      >
        <AlertTitle variant="h3" mb={4}>
          {t('accessDenied')}
        </AlertTitle>
        <Button variant="contained" size="large" color="error" onClick={() => navigate(-1)}>
          {t('back')}
        </Button>
      </Alert>
    </>
  )
}
